import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { LoginComponent } from './pages/auth/login/login.component';

export const routes: Routes = [
  // Keep bookmarked URLs working while using root URLs throughout this app.
  { path: 'super-admin', redirectTo: '', pathMatch: 'prefix' },
  {
    path: 'login',
    component: LoginComponent,
    data: { title: { en: 'Login', ar: 'تسجيل الدخول' } },
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/super-admin.module').then((m) => m.SuperAdminModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'academies',
  },
];
